import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { WorkflowsResolver } from './workflow-list/resolvers/workflows.resolver';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./workflow-list/workflow-list.module').then(m => m.WorkflowListModule)
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [WorkflowsResolver]
})
export class UserRoutingModule { }
